export default "__VITE_ASSET__19153f69__"